import { Link } from '@tanstack/react-router'
import { cn } from '@/lib/utils'

const items = [
    { to: '/manage/forms', label: 'Forms' },
    { to: '/manage/workflows', label: 'Workflows' },
    { to: '/manage/groups', label: 'Groups' },
    { to: '/manage/routing', label: 'Routing' },
] as const

/** Where the section bar applies: the Manage list pages, not the form builder. */
export function showManageNav(pathname: string): boolean {
    if (/^\/manage\/forms\/.+/.test(pathname)) return false
    return pathname.startsWith('/manage')
}

/**
 * Second level of navigation for the administration area. It is attached under
 * the top bar (full width, same content edge) so the two read as one frame.
 */
export function ManageNav({ pathname, widthClass }: { pathname: string; widthClass: string }) {
    return (
        <div className="border-b bg-muted/40 print:hidden">
            <nav aria-label="Manage" className={cn(widthClass, 'flex gap-6')}>
                {items.map((i) => {
                    const active = pathname.startsWith(i.to)
                    return (
                        <Link
                            key={i.to}
                            to={i.to}
                            aria-current={active ? 'page' : undefined}
                            className={cn(
                                '-mb-px border-b-2 py-2.5 text-sm font-medium transition-colors',
                                active ? 'border-primary text-foreground' : 'border-transparent text-muted-foreground hover:text-foreground',
                            )}
                        >
                            {i.label}
                        </Link>
                    )
                })}
            </nav>
        </div>
    )
}
